
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><div className='title'>Comment les zones de danger sont délimitées </div>
<MDXTag name="p" components={components}>{`Un territoire est classé en zone de danger selon la fréquence et l’intensité des événements qui peuvent s’y produire. On utilise pour ce faire un diagramme d’intensité/probabilité:`}</MDXTag>
<div className='imageContainer'>
  <img className='visual' src='images/matrix_fr.svg' width='250px' />
</div>
<MDXTag name="p" components={components}><b>{`L’intensité`}</b><br/>{`permet de distinguer entre les processus graduels, comme la lente montée d’un lac après de fortes pluies, et des événements brutaux, comme l’effondrement d’une falaise ou la crue soudaine d’un ruisseau de montagne.`}</MDXTag>
<MDXTag name="p" components={components}><b>{`La probabilité`}</b><br/>{`distingue entre les événements susceptibles de se produire tous les 30, 100 ou 300 ans. Une zone peut être classée en danger élevé même si l’événement qui la menace, par exemple une inondation, ne risque de se produire que tous les 300 ans.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  